import { render } from "./TheFooter.vue?vue&type=template&id=0e284dea&scoped=true"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=0e284dea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e284dea"]])

export default __exports__